import { fetchAndActivate, getValue } from 'firebase/remote-config'
import { remoteConfig } from './firebase'

import store from '@/state/store'

export async function initRemoteConfig() {
  // const env = process.env.VUE_APP_ENV;
  // if (env === 'development') return;

  const rc = await remoteConfig()
  if (rc) {
    rc.settings.minimumFetchIntervalMillis = 0
    rc.defaultConfig = {
      vsms2_setting_development: false,
    }

    await fetchAndActivate(rc)

    store.commit(
      'config/setSettingDevelopment',
      getValue(rc, 'vsms2_setting_development').asBoolean()
    )
    store.commit('config/setBookSource', getValue(rc, 'vsms2_userguide'))
  }
}
